module.exports = __webpack_public_path__ + "static/img/dnsd_logo.58eb4dc.58eb4dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dnsd_logo.58eb4dc.jpg
// module id = TBPf
// module chunks = 3